<template>
  <div class="grid-container full container">
    <div class="grid-x"
         :class="{pageContents8Left: quoteImageSide === 'right', pageContents8Right: quoteImageSide === 'left'}">

      <div
        v-if="quoteImageSide === 'left'"
        class="small-12 medium-5 cell no-padding text-center">
        <div class="photo"
             :class="{RobWalke: quotePortraightImage === 'RobWalke',
             SengovaKailondo: quotePortraightImage === 'SengovaKailondo',
             YewandeSokan: quotePortraightImage === 'YewandeSokan',
             DavidOdejayi: quotePortraightImage === 'DavidOdejayi',
             KuraDioneWarren: quotePortraightImage === 'KuraDioneWarren',
             LloydStephenson: quotePortraightImage === 'LloydStephenson',
             JenBaird: quotePortraightImage === 'JenBaird',
             FrankieDadzie: quotePortraightImage === 'FrankieDadzie',
             PeteChater: quotePortraightImage === 'PeteChater'}">


          &nbsp;</div>
      </div>
      <div
        v-if="quoteImageSide === 'right'"
        class="small-12 medium-5 cell no-padding show-for-small-only">
        <div class="photo"
             :class="{RobWalke: quotePortraightImage === 'RobWalke',
             SengovaKailondo: quotePortraightImage === 'SengovaKailondo',
             YewandeSokan: quotePortraightImage === 'YewandeSokan',
             DavidOdejayi: quotePortraightImage === 'DavidOdejayi',
             KuraDioneWarren: quotePortraightImage === 'KuraDioneWarren',
             LloydStephenson: quotePortraightImage === 'LloydStephenson',
             JenBaird: quotePortraightImage === 'JenBaird',
             FrankieDadzie: quotePortraightImage === 'FrankieDadzie',
             PeteChater: quotePortraightImage === 'PeteChater'}"
             style="float: right; ">
          &nbsp;</div>
      </div>


      <div class="small-12 medium-7 cell left-column"
           :class="{pageContents8Left: quoteImageSide === 'left', pageContents8Right: quoteImageSide === 'right'}">
        <img
          class="quoteImg"
          src="@/assets/img/icons/quote-large.png"
          alt="Diversity in graduate recruitment quote" />
        <h2 class="section">{{ quoteTitle }}</h2>

        <p class="uppercase"
           :class="{hideForSmall: quoteBodySmall !== ''}">
          {{ quoteBody }}
        </p>
        <p
          v-if="quoteBodySmall !== ''"
          class="uppercase show-for-small-only">
          {{ quoteBodySmall }}
        </p>

        <p class="standardcase"><strong>{{ quoteName }},</strong> {{ quotePosition }}</p>

        <img v-if="quoteLogoImage === 'JPMorgan'"
             class="logoImg JPMorgan"
             src="@/assets/img/logos/home-page-logos/JPMorgan.png" alt="JP Morgan - Recruitment" />

        <img v-if="quoteLogoImage === 'HoganLovells'"
             class="logoImg HoganLovells"
             src="@/assets/img/logos/home-page-logos/HoganLovells.png" alt="Hogan Lovells - Diversity"  />

        <img v-if="quoteLogoImage === 'Essence'"
             class="logoImg Essence"
             src="@/assets/img/logos/home-page-logos/Essence.png"  alt="Essence - Social Mobility" />

        <img v-if="quoteLogoImage === 'AllenOvery'"
             class="logoImg AllenOvery"
             src="@/assets/img/logos/home-page-logos/a-o-shearman.png"  alt="A & O Shearman - Graduate Recruitment" />

        <img v-if="quoteLogoImage === 'Rare'"
             class="logoImg AllenOvery"
             src="@/assets/img/logos/home-page-logos/Rare.png"  alt="Rare - Graduate Recruitment" />

        <img v-if="quoteLogoImage === 'BCLP'"
             class="logoImg bclp"
             src="@/assets/img/logos/home-page-logos/BLP.png"  alt="BCLP - Graduate Recruitment" />

        <img v-if="quoteLogoImage === 'HSF'"
             class="logoImg hsf"
             src="@/assets/img/logos/home-page-logos/HSF.png"  alt="HSF - Graduate Recruitment" />

        <img v-if="quoteLogoImage === 'CliffordChance'"
             class="logoImg CliffordChance"
             src="@/assets/img/logos/home-page-logos/CliffordChance.png"  alt="Clifford Chance - Graduate Recruitment" />

        <img v-if="quoteLogoImage === 'LathamWatkins'"
             class="logoImg LathamWatkins"
             src="@/assets/img/logos/home-page-logos/LathamWatkins.png"  alt="Latham Watkins - Graduate Recruitment" />

        <img v-if="quoteLogoImage === 'Linklaters'"
             class="logoImg Linklaters"
             src="@/assets/img/logos/home-page-logos/Linklaters.png"  alt="Linklaters - Graduate Recruitment" />
      </div>

      <div
        v-if="quoteImageSide === 'right'"
        class="small-12 medium-5 cell no-padding text-center hide-for-small-only">
        <div class="photo"
             :class="{RobWalke: quotePortraightImage === 'RobWalke',
             SengovaKailondo: quotePortraightImage === 'SengovaKailondo',
             YewandeSokan: quotePortraightImage === 'YewandeSokan',
             DavidOdejayi: quotePortraightImage === 'DavidOdejayi',
             KuraDioneWarren: quotePortraightImage === 'KuraDioneWarren',
             LloydStephenson: quotePortraightImage === 'LloydStephenson',
             JenBaird: quotePortraightImage === 'JenBaird',
             FrankieDadzie: quotePortraightImage === 'FrankieDadzie',
             PeteChater: quotePortraightImage === 'PeteChater'}"
        style="float: right; ">
          &nbsp;</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'RarePersonQuote',
  props: {
    quoteTitle: {
      type: String,
      required: false,
      default: '',
    },
    quoteBody: {
      type: String,
      required: false,
      default: '',
    },
    quoteBodySmall: {
      type: String,
      required: false,
      default: '',
    },
    quoteName: {
      type: String,
      required: false,
      default: null,
    },
    quotePosition: {
      type: String,
      required: false,
      default: '',
    },
    quoteImageSide: {
      type: String,
      required: false,
      default: 'left',
    },
    quotePortraightImage: {
      type: String,
      required: false,
      default: '',
    },
    quoteLogoImage: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .container {
    // border-bottom: 1px solid $border;
  }

  .photo {
    background-position: center top;
    background-size: cover;
    width: 100%;
    height: 100%;
    max-width:600px;
    max-height:600px;
  }

  /*  PORTRAIGHT IMAGES CSS*/
  .RobWalke {
    background-image: url("../../assets/img/photos/squares/Rob-Walke-JP-Morgan.jpg");
  }

  .SengovaKailondo {
    background-image: url("../../assets/img/photos/squares/Sengova-Kailondo-Hogan-Lovells.jpg");
  }

  .YewandeSokan {
    background-image: url("../../assets/img/photos/squares/Yewande-Sokan-Hogan-Essence.jpg");
  }

  .DavidOdejayi {
    background-image: url("../../assets/img/photos/squares/David-Odejayi-Allen-Overy.jpg");
  }

  .KuraDioneWarren {
    background-image: url("../../assets/img/photos/squares/Kura-Dione-Warren-Rare.jpg");
  }

  .LloydStephenson {
    background-image: url("../../assets/img/photos/squares/Lloyd-Stephenson-BCLP.jpg");
  }

  .JenBaird {
    background-image: url("../../assets/img/photos/squares/Jen-Baird.jpg");
  }

  .PeteChater {
    background-image: url("../../assets/img/photos/squares/Paul-Chater.jpg");
  }
  /* LOGO IMAGES CSS */
  .FrankieDadzie {
    background-image: url("../../assets/img/photos/squares/Frankie-Dadzie.jpg");
  }

  .AllenOvery {
    height: 21px;
  }

  .JPMorgan {
    height: 30px;
  }

  .HoganLovells {
    height: 72px;
  }

  .Essence {
    height: 24px;
  }

  .Rare {
    height: 24px;
  }

  .bclp {
    height: 60px;
  }

  .hsf {
    height: 70px;
  }

  .CliffordChance {
    height: 51px;
  }

  .LathamWatkins {
    height: 18px;
  }

  .Linklaters {
    width: 155px;
  }

  .photo:before{
    content: "";
    display: block;
    padding-top: 100%;
  }

  @media only screen and (max-width: 917px) and (min-width: 641px) {
    .photo {
      max-width: none;
      max-height: none;
    }
  }

  @media only screen and (max-width: 640px) {
    h2.section {
      font-size: 30px;
      text-align: left;
    }

    p.uppercase {
      text-align: left;
      font-weight: normal;
    }

    p.standardcase {
      text-align: left;
    }

    .hideForSmall {
      display: none;
    }

    .pageContents8Left {
      padding: 5% 5% 0 5%;
    }

    .pageContents8Right {
      padding: 5% 5% 0 5%;
    }

    .quoteImg {
      display: block;
      height: 40px;
      width: 56px;
      margin: 7px 0 16px 0;
    }

    .logoImg {
      display: block;
      margin: 16px 0 48px 0;
    }

    .photo {
      margin: 0 auto 0 auto;
    }
  }

  @media only screen and (min-width: 641px) {

    .pageContents8Left {
      padding: 0 0 0 8.6%;
    }

    .pageContents8Right {
      padding: 0 8.6% 0 0;
    }

    .quoteImg {
      height: 48px;
      margin-bottom: 16px;
      margin-top: 11%;
      width: 68px;
    }

    .logoImg {
      margin: 8px 0 48px 0;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/commonSections/RarePersonQuote.vue